/**
 * O35.P8 — single side-effect import for DialKit chrome CSS.
 * Feature code must not import dialkit/styles.css directly (C14).
 * Embedded baseline (layout/tokens outside DialRoot) is imported from
 * dialkit-embedded-host.tsx so Prefer-over hosts always carry it.
 */
import "dialkit/styles.css";

export const DIALKIT_STYLES_LOADED = true as const;
